// 引入http相关勾子处理
import './http/http.js';

import prex from './other/prex.js';
import ossToken from './other/oss-token.js';

import csCrm from './serve/cs-crm.js';
import csEdu from './serve/cs-edu.js';
import csfaceServer from './serve/csface-server.js';
import mallPortal from './serve/mall-portal.js';
import memberPortal from './serve/member-portal.js';

export default {
  ...prex,
  ...ossToken,

  ...csCrm,
  ...csEdu,
  ...csfaceServer,
  ...mallPortal,
  ...memberPortal,
};
